import { Environment } from './environment.model';

export const environment: Environment = {
  envName: 'int',
  apiUrl: 'https://aws-aci.tv2api.dev.tv2dev.dk',
  useProxy: false,
  timeZone: 'Europe/Copenhagen',
  awsCognitoConfig: {
    identityPoolId: 'eu-north-1:10f03d0c-5d9d-4b12-a4b4-d3079ae41467',
    userPoolId: 'eu-north-1_nK1L3fGT6',
    userPoolWebClientId: '5k2mddl2kegg7kq7fv0jq5lj0k',
    region: 'eu-north-1',
    mandatorySignIn: true,
    oauth: {
      domain: 'tv2-aci-dev.auth.eu-north-1.amazoncognito.com',
      scope: ['email', 'openid', 'profile'],
      redirectSignIn: 'https://aci-interface.aws-aci.tv2api.dev.tv2dev.dk',
      redirectSignOut: 'https://aci-interface.aws-aci.tv2api.dev.tv2dev.dk',
      responseType: 'code',
    },
    headerXHostOverride: false,
    tokenRefreshCheckPeriod: 5000,
    tokenDurationSafeBufferFactor: 0.8,
  },
};
